module.exports = function() {
  return new Worker(__webpack_public_path__ + "d96b149abddaa77dae85.worker.js");
};